<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.datamanagement.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>

        <hr />

        <mat-checkbox color="primary" name="includeMois" [(ngModel)]="includeChecked"
            >{{ 'export.includeClosedMoisCheckbox' | transloco }}</mat-checkbox
        >

        <hr />

        <button
            class="btn btn-default me-2 mb-2"
            (click)="downloadDatamanagement(ExportType.DataManagement)"
        >
            {{ 'export.datamanagement.datamanagementButton' | transloco }}
        </button>

        <button
            class="btn btn-default me-2 mb-2"
            (click)="downloadDatamanagement(ExportType.DataManagementAndMoi)"
        >
            {{ 'export.datamanagement.datamanagementAndMoisButton' | transloco }}
        </button>
    </div>
</div>
